export default class CreateAttachmentRecordError extends Error {

}
